import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import {
  CIRCLE_ROUTES,
  DASHBOARD_ROUTES,
  MATHQUIZ_ROUTES,
  PARENT_ROUTES,
  REPORT_ROUTES,
  USER_ROUTES,
  WORKSHEET_ROUTES,
  PUBLIC_AND_PRIVATE_ROUTES,
} from './private';
import { PROGRESS_ROUTES } from './private/progress-timeline-routes';

const PrivateRoutesWrapper = lazy(
  () => import('../wrappers/private-routes-wrapper/private-routes-wrapper'),
);

/**
 * Private routes configuration
 * All authenticated routes are grouped here
 */
export const PRIVATE_ROUTES: RouteObject = {
  element: <PrivateRoutesWrapper />,
  children: [
    ...DASHBOARD_ROUTES,
    ...USER_ROUTES,
    ...WORKSHEET_ROUTES,
    ...MATHQUIZ_ROUTES,
    ...REPORT_ROUTES,
    ...PUBLIC_AND_PRIVATE_ROUTES,
    CIRCLE_ROUTES,
    PARENT_ROUTES,
    PROGRESS_ROUTES,
  ],
};
